import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import React from "react";

interface TooltipProps {
  /** Content shown inside the bubble on hover/focus. */
  label: React.ReactNode;
  /** Element the tooltip is anchored to. */
  children: React.ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  /** Hover delay before the bubble appears, in ms. */
  delayDuration?: number;
  /** When true, the trigger renders without a tooltip bubble. */
  disabled?: boolean;
}

/** Chat-bubble style hover tooltip — dark bubble, white text, pointer arrow. */
export const Tooltip: React.FC<TooltipProps> = ({
  label,
  children,
  side = "top",
  delayDuration = 200,
  disabled = false,
}) => (
  <TooltipPrimitive.Provider delayDuration={delayDuration}>
    <TooltipPrimitive.Root>
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      {!disabled && (
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            side={side}
            sideOffset={6}
            collisionPadding={8}
            className="z-50 max-w-[320px] [overflow-wrap:anywhere] rounded-3xl bg-surface-card pl-3 pr-[16px] py-2 text-xs font-medium leading-snug text-ink shadow-xl data-[state=closed]:animate-tooltipOut data-[state=delayed-open]:animate-tooltipIn data-[state=instant-open]:animate-tooltipIn"
          >
            {label}
            <TooltipPrimitive.Arrow
              className="fill-surface-card"
              width={11}
              height={6}
            />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      )}
    </TooltipPrimitive.Root>
  </TooltipPrimitive.Provider>
);
